import {Grid, GridProps} from '@material-ui/core';
import {FC} from 'react'

const GridContainer: FC<GridProps> = (props) =>{
    return <Grid {...props} container = {true} />
}

export default GridContainer;